<!-- eslint-disable vue/require-v-for-key -->
<template>
  <Row class="page3" style="padding-left: 4vw; padding-right: 4vw">
    <el-dialog
      class="platedialog"
      :title="currentNews.title"
      style="width: 100vw; height: 100vh; overflow-y: hidden"
      width="40%"
      height="80%"
      :visible.sync="dialogIframe"
    >
      <div>
        <el-link
          target="_blank"
          :href="currentNews.url"
          type="warning"
          style="color: #bf9d63"
          >原文</el-link
        >
      </div>
      <div
        style="width: 100%; height: 60vh; overflow-y: auto; line-height: 1.6vw"
        class="noScrollWrap"
      >
        <div v-for="(item, index) in currentNews.paragraphs">
          <div>
            <div
              style="
                color: #bf9d63;
                font-size: 1vw;
                font-weight: bold;
                display: flex;
                align-items: center;
              "
            >
              <div class="dot" style="margin-right: 0.1vw"></div>

              <div>{{ index }}</div>
            </div>
            <div style="margin-bottom: 0.8vw">
              <div
                style="background: #bf9d63; height: 0.2vw; width: 100%"
              ></div>
            </div>
            <div
              style="margin-bottom: 0.6vw; font-size: 0.8vw"
              v-for="(item2, index2) in item"
              v-if="item2"
            >
              <div>{{ item2 }}</div>
            </div>

            <!-- <div
              v-if="
                (index.indexOf('国内股市') > -1 &&
                  currentNews.title.indexOf('陆家嘴') > -1) ||
                (index.indexOf('交易提示') > -1 &&
                  currentNews.title.indexOf('东方财富') > -1)
              "
            >
              <el-image
                referrerPolicy="no-referrer"
                type="image/png"
                style="width: 100%"
                :src="currentNews.images[0]"
                fit="fill"
              ></el-image>
            </div> -->
          </div>
        </div>
        <div v-if="currentNews.images && currentNews.images[0]">
          <el-image
            type="image/png"
            referrerPolicy="no-referrer"
            style="width: 100%"
            :src="currentNews.images[0]"
            fit="fill"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
      <div
        slot="title"
        class="dialog-footer"
        style="text-align: center; color: #bf9d63"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 1vw;
          "
        >
          <div style="">{{ currentNews.weekDay }}</div>
          <div style="">{{ currentNews.date }}</div>
        </div>
        <div style="height: 0.8vw; background: #bf9d63"></div>
        <div style="font-size: 2vw; font-weight: bold">
          {{ currentNews.title }}
        </div>
        <div style="height: 0.8vw; background: #bf9d63"></div>
      </div>
    </el-dialog>
    <div
      style="width: 100%; height: 100%; display: flex; flex-direction: column"
    >
      <div style="height: 10%; background: rgba(87, 87, 87, 0.3)">
        <div class="overHeight" style="height: 100%; overflow-y: hidden">
          <div
            class="center-bottom"
            style="
              height: 100%;
              display: flex;
              padding-top: 0;
              padding-bottom: 0;
            "
          >
            <!-- <div style="position:absolute;left:50%;transform: translateX(-50%);bottom:0;color:#bf9d63;font-size:0.8vw;">(截至当年EBITDA)</div> -->

            <div class="buPart four" style="width: 100%">
              <div
                style="
                  margin-top: 0.5vw;
                  color: #bf9d63;
                  font-size: 0.8vw;
                  text-align: center;
                  font-weight: 600;
                  margin-left: -1.6vw;
                "
              >
                <!-- EBITDA -->
                <div
                  :class="{ topItem: true, active: active_name == 'EBITDA' }"
                  @click="active_name = 'EBITDA'"
                >
                  EBITDA
                </div>
                <div
                  :class="{ topItem: true, active: active_name == 'EBT' }"
                  @click="active_name = 'EBT'"
                >
                  EBT
                </div>
              </div>
              <div style="height: 0.2vw"></div>
              <Row
                class="bottom-radars"
                style="
                  padding-left: 15px;
                  padding-right: 15px;
                  display: flex;
                  align-items: center;
                "
              >
                <Col span="6" style="color: #bf9d63; font-size: 1.2vw">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div class="dot"></div>
                      <div style="font-weight: 500; font-size: 1vw">
                        {{
                          data6 &&
                          data6[1] &&
                          data6[1]["公司名"] + "(" + data6[1]["日期"] + ")"
                        }}
                      </div>
                    </div>
                    <div
                      style="color: #fff; display: flex; align-items: center"
                    >
                      <span
                        style="
                          font-size: 1.4vw;
                          color: #fff;
                          font-weight: 700;
                          opacity: 0.8;
                        "
                      >
                        {{
                          data6 &&
                          data6[1] &&
                          (active_name == "EBITDA"
                            ? data6[1]["money"]
                            : data6[1]["ebt"])
                        }}
                      </span>
                      <span
                        style="
                          opacity: 0.5;
                          font-size: 0.9vw;
                          color: #fff;
                          padding-left: 0.4vw;
                        "
                      >
                        亿人民币
                      </span>
                      <div
                        style="
                          margin-left: 1.2vw;
                          margin-right: 1.9vw;
                          display: inline-block;
                          width: 1px;
                          height: 24px;
                          opacity: 0.2;
                          background: #fff;
                        "
                      ></div>
                    </div>
                  </div>
                </Col>
                <Col
                  span="6"
                  style="color: #bf9d63; font-size: 1.2vw; cursor: pointer"
                >
                  <div
                    @click="toEbitda('光明食品亚太有限公司', data6[0]['日期'])"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div class="dot"></div>

                      <div style="font-weight: 500; font-size: 1vw">
                        {{
                          data6 &&
                          data6[0] &&
                          data6[0]["公司名"] + "(" + data6[0]["日期"] + ")"
                        }}
                      </div>
                    </div>
                    <div
                      style="color: #fff; display: flex; align-items: center"
                    >
                      <span
                        style="
                          font-size: 1.4vw;
                          color: #fff;
                          font-weight: 700;
                          opacity: 0.8;
                        "
                      >
                        {{
                          data6 &&
                          data6[0] &&
                          (active_name == "EBITDA"
                            ? data6[0]["money"]
                            : data6[0]["ebt"])
                        }}
                      </span>
                      <span
                        style="
                          opacity: 0.5;
                          font-size: 0.9vw;
                          color: #fff;
                          padding-left: 0.4vw;
                        "
                      >
                        亿澳元
                      </span>
                      <div
                        style="
                          margin-left: 1vw;
                          margin-right: 1vw;
                          display: inline-block;
                          width: 1px;
                          height: 24px;
                          opacity: 0.2;
                          background: #fff;
                        "
                      ></div>
                    </div>
                  </div>
                </Col>
                <Col
                  span="6"
                  style="color: #bf9d63; font-size: 1.2vw; cursor: pointer"
                >
                  <div
                    @click="toEbitda('意大利SALOV公司', data6[2]['日期'])"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div class="dot"></div>

                      <div style="font-weight: 500; font-size: 1vw">
                        {{
                          data6 &&
                          data6[2] &&
                          data6[2]["公司名"] + "(" + data6[2]["日期"] + ")"
                        }}
                      </div>
                    </div>
                    <div
                      style="color: #fff; display: flex; align-items: center"
                    >
                      <span
                        style="
                          font-size: 1.4vw;
                          color: #fff;
                          font-weight: 700;
                          opacity: 0.8;
                        "
                      >
                        {{
                          data6 &&
                          data6[2] &&
                          (active_name == "EBITDA"
                            ? data6[2]["money"]
                            : data6[2]["ebt"])
                        }}
                      </span>
                      <span
                        style="
                          opacity: 0.5;
                          font-size: 0.9vw;
                          color: #fff;
                          padding-left: 0.4vw;
                        "
                      >
                        亿欧元
                      </span>
                      <div
                        style="
                          margin-left: 1vw;
                          margin-right: 1vw;
                          display: inline-block;
                          width: 1px;
                          height: 24px;
                          opacity: 0.2;
                          background: #fff;
                        "
                      ></div>
                    </div>
                  </div>
                </Col>
                <Col
                  span="6"
                  style="color: #bf9d63; font-size: 1.2vw; cursor: pointer"
                >
                  <div
                    @click="toEbitda(data6[3]['公司名'], data6[3]['日期'])"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div class="dot"></div>

                      <div style="font-weight: 500; font-size: 1vw">
                        {{
                          data6 &&
                          data6[3] &&
                          data6[3]["公司名"] + "(" + data6[3]["日期"] + ")"
                        }}
                      </div>
                    </div>
                    <div
                      style="color: #fff; display: flex; align-items: center"
                    >
                      <span
                        style="
                          font-size: 1.4vw;
                          color: #fff;
                          font-weight: 700;
                          opacity: 0.8;
                        "
                      >
                        {{
                          data6 &&
                          data6[3] &&
                          (active_name == "EBITDA"
                            ? data6[3]["money"]
                            : data6[3]["ebt"])
                        }}
                      </span>
                      <span
                        style="
                          opacity: 0.5;
                          font-size: 0.9vw;
                          color: #fff;
                          padding-left: 0.4vw;
                        "
                      >
                        亿港币
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div
        class="center-bottom"
        style="
          height: 4vw;
          display: flex;
          align-items: center;
          background-color: rgba(87, 87, 87, 0.3);
          overflow: hidden;
          margin-top: 0.5vw;
        "
      >
        <div class="marquee-container" style="width: 100%">
          <vue-seamless-scroll
            v-if="listPm.length > 0"
            :data="listPm"
            class="seamless-wrap"
            style="width: 999999px"
            :class-option="{
              openWatch: true,
              autoPlay: true,
              hoverStop: true, // 是否开启鼠标悬停stop
              direction: 2, // 0向下 1向上 2向左 3向右
              switchDelay: 0,
              'full-width-scroll': true,
            }"
          >
            <template v-for="item in listPm">
              <div
                v-if="item.type"
                class="marquee-item"
                style="
                  flex-shrink: 0;
                  margin-right: 2vw;
                  background: #937f56;
                  color: #fff;
                  display: inline-block;
                  align-items: center;
                  justify-content: space-between;
                  width: 7.5vw;
                  padding-top: 0.5vw;
                  padding-bottom: 0.5vw;
                  padding-left: 0.5vw;
                  padding-right: 0.5vw;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    justify-content: center;
                  "
                >
                  <div
                    class="right"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div
                      style="
                        font-size: 1vw;
                        font-weight: bold;
                        padding-right: 0.2vw;
                        text-align: center;
                      "
                    >
                      {{ item.type }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="marquee-item"
                style="
                  flex-shrink: 0;
                  margin-right: 2vw;
                  background: #4d4a48;
                  color: #fff;
                  display: inline-block;
                  align-items: center;
                  justify-content: space-between;
                  width: 15vw;
                  padding-top: 0.5vw;
                  padding-bottom: 0.5vw;
                  padding-left: 0.5vw;
                  padding-right: 0.5vw;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    justify-content: space-between;
                  "
                >
                  <div class="left" style="flex-shrink: 0">
                    {{ item.indexName }}
                  </div>
                  <div class="right" style="display: flex; align-items: center">
                    <div
                      style="
                        font-size: 1vw;
                        font-weight: bold;
                        padding-right: 0.2vw;
                      "
                    >
                      {{ item.indexData.toFixed(2) }}
                    </div>
                    <div class="greenTrangle" v-if="item.indexDiff < 0"></div>
                    <div class="redTrangle" v-else></div>
                    <div
                      style="font-size: 0.8vw; color: #6bbb57"
                      v-if="item.indexDiff < 0"
                    >
                      {{ (item.indexDiff.toFixed(4) + "").substring(1) }}%
                    </div>
                    <div style="font-size: 0.8vw; color: #f06161" v-else>
                      {{ item.indexDiff.toFixed(4) }}%
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vue-seamless-scroll>
        </div>
      </div>

      <div style="display: flex; flex: 1;overflow:auto;">
        <div
          type="part1"
          style="width: 65%; display: flex; flex-direction: column"
        >
          <div style="height: 22vw">
            <Row style="width: 100%">
              <Col span="6">
                <div
                  style="width: 100%; height: 1vw"
                  v-if="JSON.stringify(data2) == '{}'"
                ></div>
                <div
                  class="buPartWrap"
                  v-for="item in data2"
                  style="width: 100%"
                >
                  <div class="buPart">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          getExpain(item.name) +
                          ' (上次更新时间：' +
                          (item.last_update_date || '') +
                          ')'
                        "
                        placement="top-start"
                      >
                        <div
                          class="buPartTitle"
                          style="font-weight: 400; font-size: 1vw"
                        >
                          {{ item.name }}
                        </div>
                      </el-tooltip>
                      <div style="color: #bf9d63; font-size: 0.8vw">环比</div>
                    </div>

                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <div class="line">
                        <span
                          class="span1"
                          style="
                            font-size: 1.2vw;
                            font-weight: 700px;
                            color: #fff;
                          "
                          >{{ item.value }}</span
                        >
                      </div>
                      <div class="line">
                        <span
                          v-if="Number(item.diff.replace('%', '')) > 0"
                          class="span1"
                          style="
                            display: flex;
                            align-items: center;
                            color: #f06161;
                          "
                        >
                          <div class="redTrangle"></div>
                          <div style="font-size: 1vw">{{ item.diff }}</div>
                        </span>
                        <span
                          v-else
                          class="span1"
                          style="
                            display: flex;
                            align-items: center;
                            color: #6bbb57;
                          "
                        >
                          <div class="greenTrangle"></div>
                          <div style="font-size: 1vw">
                            {{ item.diff.replace("-", "") }}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="18">
                <div style="width: 100%; height: 19.5vw; margin-top: 1vw">
                  <china-map
                    ref="chinaMap"
                    :data="data1"
                    v-if="data1.length > 0"
                  ></china-map>
                </div>
              </Col>
            </Row>
          </div>
          <div style="flex: 1; display: flex">
            <div
              class="changeRateWrap overHeight"
              style="
                height: 100%;
                width: 31%;
                flex: none;
                cursor: pointer;
                margin-right: 1.4vw;
              "
              :key="item.company"
              v-for="(item, index) in list"
              @click="jump(item.link)"
            >
              <div
                class="changeRate"
                style="display: flex; flex-direction: column"
              >
                <div class="changeRateTitle">
                  <span class="dot"></span>
                  <span class="word">{{ item.company }}</span>
                </div>
                <div
                  style="
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    style="width: 48%; height: 100%; margin-right: 1vw"
                    class="test"
                  >
                    <ring
                      :data="data4[index]"
                      v-if="data4 && data4[index] && data4[index].length > 0"
                    ></ring>
                  </div>
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                    "
                  >
                    <div
                      class="top-wrapper-item_middle"
                      style="display: flex; flex-direction: column"
                    >
                      <div class="top-wrapper-item_middle_text">风险已预警</div>
                      <div class="top-wrapper-item_middle_text color2">
                        <span>风险已处理</span>
                      </div>
                      <div class="top-wrapper-item_middle_text color3">
                        正常
                      </div>
                    </div>
                  </div>
                </div>
                <div class="orange3">
                  <div class="item">
                    <div>
                      {{ data5[index][0] == 0 ? "-" : data5[index][0] }}
                    </div>
                    <div>核心风险</div>
                  </div>
                  <div class="line"></div>
                  <div class="item">
                    <div>
                      {{ data5[index][1] == 0 ? "-" : data5[index][1] }}
                    </div>
                    <div>发展风险</div>
                  </div>
                  <div class="line"></div>

                  <div class="item">
                    <div>
                      {{ data5[index][2] == 0 ? "-" : data5[index][2] }}
                    </div>
                    <div>运营风险</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div type="part3" style="width:35%;height:100%;flex:none;overflow:hidden;display:flex;flex-direction:column">
          <div style="height:0.9vw;"></div> 
        <div type="part2new" style="width:100%;height:100%;overflow:auto;flex:1;">
          <div
            class="changeRateWrap noScrollWrap"
            style="height: 100%; width: 100%;"
          >
            <div
              class="changeRate overHeight"
              style="display: flex; flex-direction: column"
            >
              <div class="changeRateTitle" style="padding-bottom: 10px">
                <span class="dot"></span>
                <span class="word" style="font-size: 1.2vw"
                  >每日财经新闻精选</span
                >
              </div>
              <div
                style="flex: 1; overflow-y: auto"
                class="noScrollWrap"
                v-if="true"
              >
                <div class="newsItem" v-for="item in newsList">
                  <div class="line1">
                    <el-link
                      @click="openNews(item)"
                      type="warning"
                      style="color: #bf9d63; font-size: 1.1vw"
                      >{{ item.title }} ({{ item.date }}
                      {{ item.weekDay }})</el-link
                    >
                  </div>
                  <div style="display: flex; margin-top: 0.4vw">
                    <div
                      style="
                        display: inline-block;
                        width: 8vw;
                        height: 5vw;
                        overflow: hidden;
                      "
                    >
                    <div style="width:100%;height:100%;overflow:hidden">
                      <img referrerpolicy="no-referrer" :src="item.images[0] || default_news" style="width:100%;transform:scale(1);transform-origin:center top;"/>
                    </div> 
                      <!-- <el-image
                        referrerPolicy="no-referrer"
                        style="width: 100%; height: 100%;"
                        :src="item.images[0]"
                        fit="cover"
                      ></el-image> -->
                    </div>
                    <div
                      :style="
                        'flex: 1; ' +
                        (item.images[0] ? 'padding-left: 1vw' : '')
                      "
                    >
                      <div class="line3 omit" v-html="item.endContent"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tableList" v-if="false">
                <div class="item" v-for="item in data3" :key="item.ticker">
                  <div class="left">{{ item.ticker }}</div>
                  <div class="center">{{ item.exchangeRate }}</div>
                  <div class="right" v-if="item.exchangeRateDif < 0">
                    <span class="dotGreen"></span>
                    <span class="word green"
                      ><span> </span
                      >{{ item.exchangeRateDif.substring(1) }}</span
                    >
                  </div>
                  <div class="right" v-else>
                    <span class="dotRed"></span>
                    <span class="word red">{{ item.exchangeRateDif }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      </div>
    </div>
  </Row>
</template>

<script>
import {
  getWorldMap,
  getFourPartData,
  jwzxj,
  getIndicatorProportion,
  queryTopEBITDA,
  getQueryEconomicIndex,
} from "../api/index";
import VueSeamlessScroll from "vue-seamless-scroll";
import axios from "axios";
import default_news from "@/assets/lj.png";

const chinaMap = () => import("./components/page4/worldMap");
const ring = () => import("./components/page1/ring4");
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    chinaMap,
    VueSeamlessScroll,
    ring,
  },
  computed: {
    transformStyle1() {
      return `translateX(${this.currentPosition1}px)`; // 根据当前位置设置 transform 样式
    },
    transformStyle2() {
      return `translateX(${this.currentPosition2}px)`; // 根据当前位置设置 transform 样式
    },
  },
  created() {
    // sysLogin()
    this.getData();
    this.setTitle("集团总部风险概览");
    this.setBackurl("/");
    this.setLeftTop(true);
    this.getNews();
    this.getListPm();
  },
  data() {
    return {
      default_news,
      active_name: "EBITDA",
      listPm: [],

      dialogIframe: false,
      currentNews: {},
      newsList: [],
      explationList: [
        { name: "中国GDP增长率", explain: "国内生产总值环比增长率" },
        {
          name: "中国CPI增长率",
          explain: "国内居民消费价格指数增长率，即通货膨胀率",
        },
        {
          name: "中国零售总额增长率",
          explain: "国内社会消费品零售总额环比增长率",
        },
        { name: "中国PMI指数", explain: "国内采购经理人指数" },

        { name: "GDP增长率", explain: "国内生产总值增长率" },
        {
          name: "CPI增长率",
          explain: "CPI环比增长率，即居民消费价格通货膨胀率",
        },
        { name: "零售环比增长率", explain: "暂无说明" },
        { name: "PMI", explain: "采购经理人指数" },
      ],
      list: [
        {
          company: "光明国际",
          link: "/PC/page/光明国际/流动性风险",
        },
        {
          company: "境外",
          link: "/PC/home_overseas",
        },
        {
          company: "境内",
          link: "/PC/home_domesitc",
        },
      ],
      data1: {},
      data2: {},
      data3: [],
      data4: [],
      data5: [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      data6: [],
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),
    //获取走马灯
    async getListPm() {
      let arr = [];
      const res1 = await getQueryEconomicIndex();
      if (res1.code == 200) {
        arr = res1.data.map((item) => {
          return {
            date: item.date,
            indexName: item.indexName,
            indexDiff: Number(item.indexDiff),
            indexData: Number(item.indexData),
          };
        });
        arr.unshift({ type: "全球股市" });
      }
      const res2 = await jwzxj({ type: 2 });
      if (res2.code == 200) {
        let trans = {
          USDCNY: "美元vs人民币",
          EURCNY: "欧元vs人民币",
          HKDCNY: "港币vs人民币",
          AUDCNY: "澳元vs人民币",
          AUDNZD: "澳元vs新西兰元",
          GBPCNY: "英镑vs人民币",
          ILSCNY: "谢克尔vs人民币",
          NZDCNY: "新西兰元vs人民币",
          USDEUR: "美元vs欧元",
          USDILS: "美元vs谢克尔",
        };
        // arr = arr.concat(
        //   [{ type: "外汇" }].concat(
        //     res2.data.map((item) => {
        //       return {
        //         date: item.date,
        //         indexName: trans[item.ticker],
        //         indexDiff: Number(item.exchangeRateDif),
        //         indexData: Number(item.exchangeRateFormat),
        //       };
        //     })
        //   )
        // );
      }
      let arr2 = [];
      arr.forEach((item) => {
        if (item.indexName == "标普500") {
          arr2.push({ type: "债市" });
        }
        arr2.push(item);
      });
      this.listPm = arr2;
    },
    async getNews() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ("" + (date.getMonth() + 1)).slice(-2);
      const day = ("" + date.getDate()).slice(-2);
      const dayOfWeek = new Date().getDay();
      const weekDays = ["周天", "周一", "周二", "周三", "周四", "周五", "周六"];
      const weekDay = weekDays[dayOfWeek];
      const today = `${year}年${month}月${day}日`;
      let json1 = { status: 404 };
      let json2 = { status: 404 };
      let arr = []
      try {
        json1 = await axios.get(
          "https://community.gmfintl.com/root/contract/news/陆家嘴财经早餐" +
            today +
            ".json"
        );
      } catch (error) {
        console.log(error);
      }
      try {
        json2 = await axios.get(
          "https://community.gmfintl.com/root/contract/news/东方财富财经早餐" +
            today +
            ".json"
        );
      } catch (error) {
        console.log(error);
      }
      if (json1.status == 200) {
        json1.data.endContent = "";
        json1.data.images = json1.data.images.slice(-1);

        json1.data.source = json1.data.title.split("_")[1];
        json1.data.title = json1.data.title.split("早餐")[0] + "早餐";
        json1.data.weekDay = weekDay;
        json1.data.date = year + "/" + month + "/" + day;
        arr.push(json1.data)
      
      }
      if (json2.status == 200) {
        json2.data.endContent = "";
        json2.data.images = json2.data.images.slice(-1);
        json2.data.source = json2.data.title.split("_")[1];
        json2.data.title = json2.data.title.split("早餐")[0] + "早餐";
        json2.data.weekDay = weekDay;
        json2.data.date = year + "/" + month + "/" + day;
        arr.push(json2.data)
      }
      if(json1.status == 200 || json2.status == 200){
        this.getNews2(arr)
      }
   
    },
    async getNews2(arr1) {
      var todayold = new Date();  // 获取当前日期
      var yesterday = new Date(todayold.getTime() - 24 * 60 * 60 * 1000);  // 获取前一天日期
      const date = yesterday;
      const year = date.getFullYear();
      const month = ("" + (date.getMonth() + 1)).slice(-2);
      const day = ("" + date.getDate()).slice(-2);
      const dayOfWeek = date.getDay();
      const weekDays = ["周天", "周一", "周二", "周三", "周四", "周五", "周六"];
      const weekDay = weekDays[dayOfWeek];
      const today = `${year}年${month}月${day}日`;
      let json1 = { status: 404 };
      let json2 = { status: 404 };
      try {
        json1 = await axios.get(
          "https://community.gmfintl.com/root/contract/news/陆家嘴财经早餐" +
            today +
            ".json"
        );
      } catch (error) {
        console.log(error);
      }
      try {
        json2 = await axios.get(
          "https://community.gmfintl.com/root/contract/news/东方财富财经早餐" +
            today +
            ".json"
        );
      } catch (error) {
        console.log(error);
      }
      let arr = []
      if (json1.status == 200) {
        json1.data.endContent = "";
        json1.data.images = json1.data.images.slice(-1);

        json1.data.source = json1.data.title.split("_")[1];
        json1.data.title = json1.data.title.split("早餐")[0] + "早餐";
        json1.data.weekDay = weekDay;
        json1.data.date = year + "/" + month + "/" + day;
        arr.push(json1.data)
      }
      if (json2.status == 200) {
        json2.data.endContent = "";
        json2.data.images = json2.data.images.slice(-1);
        json2.data.source = json2.data.title.split("_")[1];
        json2.data.title = json2.data.title.split("早餐")[0] + "早餐";
        json2.data.weekDay = weekDay;
        json2.data.date = year + "/" + month + "/" + day;
        arr.push(json2.data)
      }
      this.newsList = arr1.concat(arr)
      this.formatNews();
    },
    openNews(item) {
      this.currentNews = item;
      this.dialogIframe = true;
    },
    formatNews() {
      this.newsList.forEach((item) => {
        for (let i in item.paragraphs) {
          if (!item.endContent) {
            item.endContent = "";
          }
          // item.endContent = item.endContent + "<p>" + i + "</p>";
          if (item.paragraphs[i]) {
            item.paragraphs[i].forEach((item2) => {
              item.endContent = item.endContent + "<p>" + item2 + "</p>";
            });
          }
        }
      });
    },
    getExpain(name) {
      let res = this.explationList.find((item) => name.indexOf(item.name) > -1);
      if (res) {
        return res.explain;
      } else {
        return "暂无说明";
      }
    },
    async getData() {
      // 世界地图经纬度
      const res = await getWorldMap();
      if (res.code == 200) {
        this.data1 = res.data.map((item) => {
          return {
            value: [item["经度"], item["纬度"], 180],
            name: item["地区"] || item["国家"],
          };
        });
      }
      // 左上角四个增长率
      const res2 = await getFourPartData({ type: 1 });
      if (res2.code == 200) {
        this.data2 = res2.data;
      }
      //   左下角列表
      const res3 = await jwzxj({ type: 1 });
      if (res3.code == 200) {
        this.data3 = res3.data;
      }
      // 总览环图
      const res4 = await getIndicatorProportion();

      if (res4.code == 200) {
        this.data4 = res4.data;
        this.data4.forEach((item, index) => {
          item.forEach((item2, index2) => {
            item2.forEach((item3) => {
              if (item3.name.indexOf("预警") > -1) {
                if (item3.value) {
                  this.data5[index][index2] += item3.value;
                }
              }
            });
          });
        });
      }
      //   左下角列表
      const res6 = await queryTopEBITDA();
      if (res6.code == 200) {
        this.data6 = res6.data;
      }
    },
    toEbitda(name, date) {
      if (this.active_name == "EBT") {
        return;
      }
      //   this.$router.push(`/PC/page/Ebitda/${name}`);
      this.$router.push({
        path: `/PC/page/${name}/EBITDA`,
        query: { date },
      });
    },
    jump(page) {
      if (page) {
        this.$router.push(page);
      }
    },
    startAnimation() {
      this.scrollInterval = setInterval(() => {
        this.currentPosition1 -= 1; // 向左滚动
        // if (this.currentPosition <= -this.containerWidth) {
        //   this.currentPosition = 0; // 滚动到最后一个元素后立即重置位置
        // }
      }, 10); // 每隔10毫秒滚动一次，可以根据需要调整
    },
  },
  mounted() {
    this.resizeFn = this.$debounce(() => {
      this.$refs.chinaMap.setMap();
    }, 500);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>
<style lang="less">
.el-tooltip__popper.is-dark {
  font-size: 1vw;
  background: #3d4146 !important;
}
/* 更改箭头颜色 */
.el-tooltip__popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #3d4146 !important;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #3d4146 !important;
}
.noScrollWrap {
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background-color: #99a9bf;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    background-color: #d3dce6;
  }
}
</style>

<style lang="less" scoped>
@import "~@/assets/less/index.less";
.topItem {
  display: inline-block;
  width: 4vw;
  height: 1.4vw;
  text-align: center;
  line-height: 1.1vw;
  border: solid 0.2vw #bf9d63;
  box-sizing: border-box;
  cursor: pointer;
  background: #bf9d63;
  color: #fff;

  &.active {
    background: #fff;
    color: #bf9d63;
  }
}
.newsItem {
  margin-bottom: 1vw;
  .omit {
    /* 对于 WebKit 浏览器 */
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* 指定显示的行数 */
    overflow: hidden;
    color: #fff;
    line-height: 1.7vw;
    font-size: 1vw;
  }
  .line1 {
    font-size: 0.8vw;
    color: #bf9d63;
  }
  .line2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.2vw;
    .part1 {
      color: #fff;
    }
    .part2 {
      color: #fff;
    }
  }
  .line3 {
  }
}
.red {
}
.green {
  color: #6bbb57;
}
.top-wrapper-item_middle {
  font-weight: 400;
  color: #fff;
  .top-wrapper-item_middle_text {
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 12px;
      border: 3px solid rgba(225, 106, 106, 1);
      border-radius: 100%;
    }

    &.color2::before {
      border-color: rgba(228, 204, 136, 1);
    }
    &.color3::before {
      border-color: rgba(89, 207, 122, 1);
    }
  }
}
.orange3 {
  display: flex;
  color: #fff;
  align-items: center;
  border-radius: 2px;
  background: rgb(147, 127, 86);
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  .line {
    width: 1px;
    height: 30px;
    flex-shrink: 0;
    opacity: 0.14000000059604645;
    background: #fff;
  }
  .item {
    font-size: 0.8vw;
    width: 33%;
    text-align: center;
  }
}
.changeRate {
  padding-left: 3%;
  padding-right: 4%;
  width: 100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  padding: 10px 20px;
  .changeRateTitle {
    color: #bf9d63;
    // margin-bottom: 10px;
  }
}
.redTrangle {
  /* 1.首先设置盒子宽高都为0 */
  width: 0;
  height: 0;
  /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
  border: 4px solid transparent;
  /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
  border-top: none;
  /*4.最后设置边框颜色，显示出三角形*/
  border-bottom-color: #f06161;
  margin-right: 3px;
}
.greenTrangle {
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top-color: #6bbb57;
  margin-right: 3px;
}
.buPartWrap {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  height: 4.4vw;
  // height: 180px;
  //   background: rgba(87, 87, 87, 0.3);
  //   border: 1px solid #4d4a48;
  margin-top: 0.8vw;
  &:first-child {
    margin-top: 1vw;
  }
  &:nth-child(n + 1) {
    // margin-top: 2vw;
  }
  .buPart {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding-left: 1vw;
    padding-right: 1vw;
    // padding-top: 1vw;
    // padding-bottom: 1vw;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // padding: 1.5vw 20px 0;
    .buPartTitle {
      color: #bf9d63;
      // font-weight: 600;
      // margin-bottom: 28px;
      //   font-size: 20px;
      font-size: 1.1vw;
      line-height: 27px;
    }
    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      //line-height: 34px;
      .span1 {
        color: #ffffff;
        opacity: 0.6;
        font-size: 1.1vw;
        // font-size: 1vw;
      }
      .span2 {
        font-size: 1.3vw;
        color: #ffffff;
        opacity: 0.8;
        // font-size: 1.5vw;
      }
    }
  }
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  box-sizing: border-box;
}
.center-bottom {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  .background-4-img;
  padding: 20px;
  .center-bottom-title {
    font-size: 16px;
    line-height: 24px;
    color: rgba(191, 157, 99, 1);
    font-weight: 300;
  }
}
.dot {
  margin-right: 10px;
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: linear-gradient(180deg, #bf9d63 0%, rgba(217, 217, 217, 0) 100%);
}

.tableList {
  .item {
    display: flex;
    align-items: center;
    &:nth-child(odd) {
      background: rgba(87, 87, 87, 0.5);
    }
    height: 38px;
    line-height: 38px;
    justify-content: space-between;
    .left {
      font-size: 1vw;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 10px;
    }
    .center {
      font-weight: 400;
      font-size: 1vw;
      color: #ffffff;
      text-align: center;
    }
    .right {
      text-align: right;
      padding-right: 10px;
      font-weight: 400;
      font-size: 1vw;
      color: #f06161;
      .dotRed {
        position: relative;
        bottom: 0.1vw;
        display: inline-block;
        margin-right: 5px;
        width: 0.5vw;
        height: 0.5vw;
        // border-radius: 50%;
        // background: #f06161;
        /* 1.首先设置盒子宽高都为0 */
        width: 0.5vw;
        height: 0.5vw;
        /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
        border: 6px solid transparent;
        /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
        border-top: none;
        /*4.最后设置边框颜色，显示出三角形*/
        border-bottom-color: #f06161;
      }
      .dotGreen {
        position: relative;
        top: 0.1vw;
        display: inline-block;
        // border-radius: 50%;
        // background: #6bbb57;
        width: 0.5vw;
        height: 0.5vw;
        border: 6px solid transparent;
        border-top-color: #6bbb57;
        margin-right: 5px;
      }
    }
    > div {
      width: 33%;
    }
  }
}
.changeRateWrap {
  flex: 1;
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  //   height: calc(100% - 32px - 40%);
  position: relative;
  //   top: -20px;

  .changeRateTitle {
    display: flex;
    align-items: center;

    .word {
      font-size: 16px;
      color: #bf9d63;
    }
  }
}
.page3 {
  .left1 {
    .changeItem {
      font-size: 0.9vw;
      margin-bottom: 20px;
      position: relative;
      //   top: -60px;

      .item {
        cursor: pointer;
        text-align: center;
        display: inline-block;
        // margin-right: 40px;
        min-width: 105px;
        height: 40px;
        line-height: 40px;
        color: #bf9d63;
        // padding: 8px 14px;
        color: #fff;
        &.active {
          background: #4a3e29;
          border-radius: 60px;
          color: #bf9d63;
        }
      }
    }
  }
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   background: #03044a;
  // overflow: hidden;

  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    // background: rgba(87, 87, 87, 0.3);
    // border: 1px solid #4d4a48;
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      //   border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }

    .title {
      position: absolute;
      display: inline-block;
      color: #6eddf1;
      border: 2px solid #6eddf1;
      height: 18px;
      padding: 0 2px;
      left: 50%;
      transform: translate(-50%, -50%);

      .title-text {
        position: relative;
        font-size: 16px;
        background: #09102e;
        display: inline-block;
        padding: 0 4px;
        transform: translateY(-5px);
      }
    }
  }

  .center-top {
    height: 70%;
  }

  .center-bottom {
    height: 30%;

    .bottom-radars {
      height: 100%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
.marquee-container {
  overflow: hidden;
  // white-space: nowrap;
  width: 100%;
  // display: flex;
  // align-items: center;
}

.marquee-item {
  .left {
    font-size: 0.9vw;
  }
  //   animation: marquee 7s linear infinite !important;
}
.marquee-item:nth-last-child(1) {
  //   animation-delay: -5s; /* 与动画总时长相同的负值，使最后一个元素渐变到第一个元素 */
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.seamless-scroll {
  white-space: nowrap; /* 设置横向内容不换行 */
}
.seamless-warp {
  overflow: hidden;
  white-space: nowrap;
  // display:flex;
  align-items: center;
  width: 100%; /* 确保宽度为100% */
}
</style>
